import './NotFound.scss';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="not-found-page" data-testid="not-found-page">
      <h1>404 Not Found</h1>
      <Link to={'/'}>Go Back</Link>
    </div>
  );
};

export default NotFound;
